export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14403.e1070ec2.jpg";